import React from "react";
import { useUserContext } from "context/UserContext";
import MembershipAnalysisBK from "layouts/BK/membershipAnalysis";
import { isBkLikeRole } from "utils/roleUtils";

function MembershipAnalysis() {
  const { role } = useUserContext() || {};
  if (isBkLikeRole(role)) {
    return <MembershipAnalysisBK />;
  }
  return null;
}

export default MembershipAnalysis;
